import React, {useEffect, useState} from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@material-ui/core";
import {DictionaryGroup, SearchLocationType} from "../models/models";
import {ServerApi} from "../ServerApi";



function isEmptyOrSpaces(str: string) {
	return str === null || str.match(/^ *$/) !== null;
}



export const ReplaceComponent: React.FC<any> = () => {
	const [dictionaryGroups, setDictionaryGroups] = useState<DictionaryGroup[]>([]);
	const [dictionaryId, setDictionaryId] = useState<number>(-1);
	const [original, setOriginal] = useState("");
	const [destination, setDestination] = useState("");
	const [replaceLocation, setReplaceLocation] = useState(-1);


	useEffect(() => {
		ServerApi
			.getDictionaryGroups()
			.then(dgs => setDictionaryGroups(dgs));
	}, []);


	return (
		<>
			<form action="/Api/Word/Replace" method="post"
			      onSubmit={e => {
				      if (dictionaryId < 1) {
					      e.preventDefault();
					      alert("일괄수정할 사전을 선택해주세요.");
					      return;
				      }

				      if (replaceLocation < 0) {
					      e.preventDefault();
					      alert("수정 위치를 선택해주세요.");
					      return;
				      }

				      if (isEmptyOrSpaces(original)) {
					      e.preventDefault();
					      alert("수정전 단어를 입력해주세요.");
					      return;
				      }

				      if (isEmptyOrSpaces(destination)) {
					      e.preventDefault();
					      alert("수정후 단어를 입력해주세요.");
					      return;
				      }

				      if (!window.confirm("정말로 일괄수정을 진행하시겠습니까?")) {
					      e.preventDefault();
					      return;
				      }
			      }}>

				<FormControl variant="outlined" style={{width: "250px"}}>
					<InputLabel>사전</InputLabel>
					<Select name="dictionaryId"
					        value={dictionaryId}
					        onChange={(e) => setDictionaryId(parseInt(e.target.value as string))}
					        variant="outlined"
					        label="사전">
						{dictionaryGroups
							.flatMap(dg => dg.dictionaries)
							.map(d =>
								<MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
							)
						}
					</Select>
				</FormControl>

				<br/>
				<br/>

				<FormControl variant="outlined" style={{width: "250px"}}>
					<InputLabel>수정 위치</InputLabel>
					<Select name="replaceLocation"
					        value={replaceLocation}
					        onChange={(e) => setReplaceLocation(e.target.value as SearchLocationType)}
					        variant="outlined"
					        label="수정 위치">
						<MenuItem value={SearchLocationType.Term}>제목</MenuItem>
						<MenuItem value={SearchLocationType.Description}>내용</MenuItem>
						<MenuItem value={SearchLocationType.Both}>제목+내용</MenuItem>
					</Select>
				</FormControl>

				<br/>
				<br/>

				<TextField name="originalWord"
				           label="수정전 단어"
				           style={{width: "250px"}}
				           value={original}
				           variant="outlined"
				           onChange={(e) => setOriginal(e.target.value)}/>

				<br/>
				<br/>

				<TextField name="destinationWord"
				           label="수정후 단어"
				           style={{width: "250px"}}
				           value={destination}
				           variant="outlined"
				           onChange={(e) => setDestination(e.target.value)}/>

				<br/>
				<br/>

				<input type="submit" value="일괄수정"/>
			</form>
		</>
	)
};